// import React from 'react'
import Axios from 'axios';
import dayjs from 'dayjs';
import { getRandom } from './RandomNumber';

const UserPointExp = async (location, log, p_bonus, e_bonus, updown) => {

  // updown에 아무 값이 있으면 포인트 및 기여도가 마이너스 - 로 처리됩니다.
  // 클라이언트 및 서버단에서 처리되는거 확인 되었음.

  // 시간 불러오는 부분
  let toDayDate = new dayjs().format('YYYY-MM-DD');
  let toDayTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const store = window.sessionStorage.getItem('basicStore');
  const id = window.sessionStorage.getItem('basicID');
  const name = window.sessionStorage.getItem('basicName');

  // 지급할 포인트와 기여도 보너스는 곱셉이므로 기본 배율은 1
  let point = getRandom(1, 50 * p_bonus);
  let exp = getRandom(1, 30 * e_bonus);
  
  await Axios.post(`/api/UserPointExp/adddata`, {
    Store: store, ID: id, Name: name,
    Point: point, P_Bonus: p_bonus, Exp: exp, E_Bonus: e_bonus,
    Location: location, Log: log, Date: toDayTime, Updown: updown
  })
  .then((res)=>{
    console.log(`${log} - 포인트 및 기여도 증감 성공`);
  })
  .catch((err)=>{
    console.log(`${log} - 포인트와 기여도 증감이 실패했습니다.\n`, err);
  });
  
}

export default UserPointExp